<template>
    <TabWrapper>
        <v-container>
            <v-row justify="center" no-gutters>
                <v-col cols="12" lg="10">
                    <Datatable :headers="headers" :items="history" title="History">
                    </Datatable>
                </v-col>
            </v-row>
        </v-container>
    </TabWrapper>
</template>

<script>
import TabWrapper from "./TabWrapper";
import Datatable from "../../../components/Tables/Datatable";
import Utils from "../../../scripts/Utils";

export default {
    name: "History",
    components: {Datatable, TabWrapper},
    data: () => {
        return {
            headers: [
                {text: 'Datum', value: 'created_at', width: '20%'},
                {text: 'Beschreibung', value: 'Message', width: '60%'},
                {text: 'Benutzer', value: 'name', width: '20%'},
            ]
        }
    },
    mounted() {
        this.$emit('activeComponent', this);
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        history() {
            let ret = [];
            if (this.siteDetails) {
                this.siteDetails.History.forEach((entry) => {
                    entry.created_at = Utils.formatDate(entry.Updated, true);
                    entry.name = Utils.getName(entry.CreatedByName);
                    ret.push(entry);
                })
            }
            return ret;
        },
        activeTab() {
            return this.vuexState.activeTab;
        }
    },
    watch: {
        activeTab() {
            if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        }
    }
}
</script>

<style scoped>

</style>